import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './CheckBox.scss';

export default class CheckBox extends PureComponent {
  constructor(props) {
    super(props);

    this.onAnimationEnd = () => this.setState({ isAnimating: false });
    this.onClick = this::this.onClick;

    this.state = {
      wasChecked: props.checked,
      isAnimating: false
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.wasChecked !== nextProps.checked && !prevState.isAnimating) {
      return {
        wasChecked: nextProps.checked,
        isAnimating: true
      };
    }

    return null;
  }

  onClick(e) {
    if (!(e.target !== e.currentTarget && e.target.nodeName === 'A') && !this.props.disabled) {
      this.props.onChange(!this.props.checked, this.props.id);
    }
  }

  get button() {
    return (
      <button
        aria-checked={this.props.checked}
        className="naked_button"
        disabled={this.props.disabled}
        onClick={this.onClick}
        role="checkbox"
        styleName="check_button"
        type="button"
        id={this.props.id}
      >
        <svg
          role="presentation"
          viewBox="0 0 20 20"
          styleName="tick"
        >
          <path
            className={classNames(s.path, {
              [s.animate]: this.state.isAnimating,
              [s.animated]: this.props.checked && !this.state.isAnimating,
              [s.reverse]: !this.props.checked && this.state.isAnimating
            })}
            onAnimationEnd={this.onAnimationEnd}
            d="M 2,14 9.3,18 18,2"
          />
        </svg>
      </button>
    );
  }

  get text() {
    return (
      <p // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
        className={`text effra ${(this.props.checked && !this.props.disabled) ? '' : 'dusty_lavender'} ${s.text}`}
        onClick={this.onClick}
      >
        { this.props.children }
      </p>
    );
  }

  render() {
    if (this.props.reverseOrder) {
      return (
        <div className={this.props.className} styleName="root">
          { this.text }
          { this.button }
        </div>
      );
    }

    return (
      <div className={this.props.className} styleName="root">
        { this.button }
        { this.text }
      </div>
    );
  }
}

CheckBox.propTypes = {
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  reverseOrder: PropTypes.bool
};

CheckBox.defaultProps = {
  className: '',
  disabled: false,
  id: undefined,
  reverseOrder: false
};
